import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, total, pageSize = 50, onPage, disabled = false, itemName = "result", itemNamePlural = `${itemName}s` }: {
  page: number; total: number; pageSize?: number; onPage: (page: number) => void;
  disabled?: boolean; itemName?: string; itemNamePlural?: string;
}) {
  if (total === 0) return null;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(pages, Math.max(1, page));
  const count = `${total.toLocaleString()} ${total === 1 ? itemName : itemNamePlural}`;
  const range = `${((currentPage - 1) * pageSize + 1).toLocaleString()}–${Math.min(total, currentPage * pageSize).toLocaleString()}`;
  return <nav className="pagination" aria-label={`${itemNamePlural[0]!.toUpperCase()}${itemNamePlural.slice(1)} pagination`} aria-busy={disabled}>
    <span className="pagination-summary" role="status">{pages === 1 ? count : `Showing ${range} of ${count}`}</span>
    {pages > 1 && <div className="pagination-controls">
      <button type="button" className="button secondary" disabled={disabled || currentPage <= 1} onClick={() => onPage(currentPage - 1)}><ChevronLeft size={15} aria-hidden="true"/>Previous</button>
      <span className="pagination-page">Page {currentPage.toLocaleString()} of {pages.toLocaleString()}</span>
      <button type="button" className="button secondary" disabled={disabled || currentPage >= pages} onClick={() => onPage(currentPage + 1)}>Next<ChevronRight size={15} aria-hidden="true"/></button>
    </div>}
  </nav>;
}
